/**
 * The order of the "Stock" page (owner request, 2026-10-01): alphabetical by Domaine (ignoring
 * case and accents, French order), then by vintage and grape variety.
 */
import type { Wine } from './cellar';

const byText = (a: string, b: string) => a.localeCompare(b, 'fr', { sensitivity: 'base' });

export function compareByDomaine(a: Wine, b: Wine): number {
  return byText(a.domaine, b.domaine) || a.annee - b.annee || byText(a.cepage, b.cepage);
}

/** A sorted copy; the cellar's own order is left as it is. */
export function sortByDomaine(wines: readonly Wine[]): Wine[] {
  return [...wines].sort(compareByDomaine);
}
